//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/chat'
import { TABS, TYPES, AUTOREPLY_TYPES, AUTOREPLY_LISTS } from './conf'
import ServiceIndex from '@/service'
import Pagination from '@/common/mixins/pagination'
import { App_User } from '@/data/user_info'
import { Picker } from 'vant'

const getDelayText = (autoreply_delay_checked, autoreply_delay) => {
    return autoreply_delay_checked ?
        autoreply_delay === 0 ? '立即' : `${autoreply_delay}秒`
        :
        ''
}

export default {
    data () {
        return {
            items: [],
            show_dlg: false,
            content: '',
            delay_seconds: [],
            delay_index: -1,
            tabs: TABS,
            block_num: 0,
            block_list: '',
            selected_tab: TYPES.PHRASE,
            is_consultant_user: false,
            autoreplys: [],
            show_picker: false,
            select_picker: '',
            selected_seqs: [],
            select_item: {},
            contentId:'',
            type:'',
            user_type: ''
        }
    },
    mixins: [
        Pagination
    ],
    components: {
        Picker
    },
    mounted () {
        App_User.get().then(({ is_consultant  }) => {
            const user_type = is_consultant ? 'consultant' : 'guest'
            this.user_type = user_type
            this.is_consultant_user = is_consultant
            this.tabs = TABS.filter(({ show }) => show.indexOf(user_type) > -1)
            this.selected_tab = TYPES.PHRASE
            this.getExpressions()
        })
    },
    computed: {
        delay_seconds_options () {
            return this.delay_seconds.map((item) => {
                return item ? `${item}秒` : '立即'
            })
        },
        tabs_is_scroll () {
            return this.tabs.length > 1
        }
    },
    methods: {
        getPicker(item) {
            this.select_item = item
            this.getPickerList(item.autoreply_seq)
        },
        getPickerList(_seq) {
            let _autoreplys = AUTOREPLY_LISTS
            if (this.selected_seqs.length) {
                _autoreplys = AUTOREPLY_LISTS.filter(({key}) => {
                    return !this.selected_seqs.includes(key)
                })
            }
            this.autoreplys = _autoreplys.filter(({key})=> {
                return key !== _seq
            })
            if (!this.autoreplys.length) {
                wx.showToast({
                    icon: 'none',
                    title: '最多可设置三条自动回复哦'
                })
            } else {
                this.show_picker = true
            }
        },
        cancelPicker() {
            this.show_picker = false
            this.select_picker = ''
            this.select_item = {}
        },
        async confimPicker(value, index) {
            const _picker = this.autoreplys[index]
            const { key } = _picker
            const params = {
                autoreply_seq: key
            }
            console.error('this.select_item', this.select_item.id, params)
            await Service.updateAutoreplySeq(this.select_item.id, params)
            this.getExpressions()
            this.cancelPicker()
        },
        changeTab (tab) {
            this.selected_tab = tab
            switch (tab) {
                case TYPES.BLOCK:
                    this.getData()
                    break
                case TYPES.PHRASE:
                    this.getExpressions()
                    break
            }

        },
        toggleDelayChecked (index) {
            if (this.delay_index > -1) {
                this.$set(this.items, this.delay_index, {
                    ...this.items[this.delay_index],
                    autoreply_delay_checked: false,
                    autoreply_delay_checked_index: -1,
                    autoreply_delay_text: ''
                })
            }
            if (this.delay_index === index) {
                const item = this.items[index]
                this.delay_index = ''
                item.autoreply_delay = null
                Service.updateExpression(item.id, item).then(() => {
                    wx.showToast({
                        title: '修改成功'
                    })
                })
                return
            }
            this.delay_index = index
            const item = this.items[index]
            const autoreply_delay_checked = !item.autoreply_delay_checked
            const autoreply_delay_checked_index = 0
            const autoreply_delay = this.delay_seconds[autoreply_delay_checked_index]
            this.$set(this.items, index, {
                ...item,
                autoreply_delay,
                autoreply_delay_checked,
                autoreply_delay_checked_index,
                autoreply_delay_text: getDelayText(autoreply_delay_checked, autoreply_delay)
            })
            this.updateDelay(index, this.delay_seconds[0])
        },
        changeDelay (e) {
            const { value } = e.detail
            const { index } = e.target.dataset
            this.updateDelay(index, value)
        },
        updateDelay (index, value) {
            const item = this.items[index]
            const autoreply_delay = this.delay_seconds[value]
            const rs = {
                ...item,
                autoreply_delay,
                autoreply_delay_checked_index: value,
                autoreply_delay_text: getDelayText(true, autoreply_delay)
            }
            this.$set(this.items, index, rs)
            Service.updateExpression(item.id, rs).then(() => {
                wx.showToast({
                    title: '修改成功'
                })
            })
        },
        getExpressions () {
            this.selected_seqs = []
            Service.getExpressions().then((data) => {
                this.delay_seconds = data.delay_seconds
                this.items = data.items.map((item, i) => {
                    const { autoreply_delay, autoreply_seq } = item
                    const autoreply_delay_checked = autoreply_delay != null
                    if (autoreply_delay_checked) {
                        this.delay_index = i
                    }
                    if (autoreply_seq) {
                        this.selected_seqs.push(autoreply_seq)
                    }
                    return {
                        ...item,
                        name: AUTOREPLY_TYPES[autoreply_seq],
                        autoreply_delay_checked,
                        autoreply_delay_checked_index: this.delay_seconds.indexOf(autoreply_delay),
                        autoreply_delay_text: getDelayText(autoreply_delay_checked, autoreply_delay)
                    }
                })
            })
        },
        getData() {
            ServiceIndex.getSessions({
                page: this.page,
                per: 10,
                status: 'blocked'
            }).then((data) => {
                this.block_list = data.items || []
                this.block_num = data.items.length || 0
            })
        },
        onDelete (id, i) {
            Service.deleteExpression(id)
            this.getExpressions()
        },
        writeContent(value,id){
            if (id) {
                this.content = value
                this.contentId = id
                this.type = 'edit'
            } else {
                this.type = 'add'
            }
            this.toggleDlg()
        },
        editCancel(){
            this.content = '',
            this.toggleDlg()
        },
        toggleDlg () {
            this.show_dlg = !this.show_dlg
        },
        onCreate () {
            const has_repeated = this.items.some(({ content }) => {
                return content === this.content
            })
            if (has_repeated) {
                wx.showToast({
                    title: '该条信息已存在，您无需新建',
                    icon: 'none'
                })
                return
            }
            if(this.type === 'edit'){
                const rs = {
                    content:this.content
                }
                Service.updateExpression(this.contentId,rs).then(()=>{
                    this.getExpressions()
                    this.toggleDlg()
                    this.content = ''
                    this.contentId = ''
                })
                return
            }
            Service.createExpression(this.content).then(() => {
                this.getExpressions()
                this.toggleDlg()
                this.content = ''
            })
        }
    }
}
